import React from "react";
import { Redirect } from "react-router";
import { Button } from "@material-ui/core";
import { useCreatePlaylist } from "frontend/src/domain/playlists";
import { paths } from "frontend/src/pages/paths";
import { PlaylistCreateModal } from "./playlist-create-modal";
export var PlaylistCreateNew = function () {
    var _a = React.useState(false), isOpen = _a[0], setOpen = _a[1];
    var _b = useCreatePlaylist(), run = _b.run, isLoading = _b.isLoading, isSuccess = _b.isSuccess, data = _b.data;
    if (isSuccess && data) {
        return React.createElement(Redirect, { to: paths.admin.playlists.edit(data.id) });
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { color: "primary", variant: "contained", onClick: function () { return setOpen(true); }, disabled: isLoading }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043D\u043E\u0432\u044B\u0439"),
        isOpen && (React.createElement(PlaylistCreateModal, { isOpen: isOpen, close: function () { return setOpen(false); }, create: run, isLoading: isLoading }))));
};
